module.exports = __webpack_public_path__ + "img/logo.1c20c0be.png";